import type { SummaryTileId } from "../types";

export const FILTER_CONFIG_KEY = "dnd";
export const WORKSPACE_TYPE = "demurrageAndDetention";

// Status quick filters are a shortcut for the panel's Status filter (query: status=A,B)
// Only the most relevant statuses get a quick filter; the full status -> style mapping stays in @/constants/statusStyles
export const STATUS_QUICK_FILTERS = [
  { status: "INCURRING", label: "DND.FILTER_CARD_CHARGE_TYPE_STATUS.INCURRING" },
  { status: "AT_RISK", label: "DND.FILTER_CARD_CHARGE_TYPE_STATUS.AT_RISK" },
  { status: "WITHIN_FREE_TIME", label: "DND.FILTER_CARD_CHARGE_TYPE_STATUS.WITHIN_FREE_TIME" }
];

export const INCLUDE_OPTION = { ARCHIVED: "includeArchivedShipments", ESTIMATES: "includeEstimate" } as const;

// Zero-denominator sentinel returned by the backend (e.g. Daily burn with no incurring/incurred days)
export const DAILY_BURN_SENTINEL = "—";
export const DND_SUMMARY_TILES_MODEL = "dnd/highlights";

// Ordered tile config. `key` is the stable tile identifier; displayed labels come from i18n via `labelKey`.
export const SUMMARY_TILES: ReadonlyArray<{
  key: SummaryTileId;
  labelKey: string;
  accentStatus?: string;
}> = [
  { key: "shipments", labelKey: "DND.SUMMARY_TILES.SHIPMENTS" },
  { key: "incurringNow", labelKey: "DND.SUMMARY_TILES.INCURRING_NOW", accentStatus: "INCURRING" },
  { key: "dailyBurn", labelKey: "DND.SUMMARY_TILES.DAILY_BURN" },
  { key: "incurredToDate", labelKey: "DND.SUMMARY_TILES.INCURRED_TO_DATE" },
  { key: "atRisk", labelKey: "DND.SUMMARY_TILES.AT_RISK", accentStatus: "AT_RISK" },
  { key: "setupNeeded", labelKey: "DND.SUMMARY_TILES.SETUP_NEEDED", accentStatus: "NOT_CONFIGURED" }
];

// Explicit, exact mapping from the title the highlights API returns (items carry only `title` + `value`) to the tile key.
// No normalisation or fuzzy matching: a title not listed here is ignored.
export const HIGHLIGHT_TITLE_TO_KEY: Readonly<Record<string, SummaryTileId>> = {
  "Shipments (import)": "shipments",
  "Shipments (export)": "shipments",
  "Incurring now": "incurringNow",
  "Daily burn": "dailyBurn",
  "Incurred to date": "incurredToDate",
  "At risk": "atRisk",
  "Setup needed": "setupNeeded"
};

export { mapHighlightsToTiles } from "./mapHighlightsToTiles";
